import { useControl, useControlEffect } from "@react-typed-forms/core";
import { Textfield } from "@astrolabe/ui/Textfield.tsx";
import { useApiClient } from "@astroapps/client";
import { ApplicationForm } from "./components/ApplicationForm.tsx";
import { ApplicationClient } from "hwc-common/hwc/client.ts";

function App() {
  const code = useControl<string>();
  const validCode = useControl<boolean>(false);
  const client = useApiClient(ApplicationClient);

  useControlEffect(
    () => code.value,
    () => {
      if (!code.value) {
        validCode.value = false;
      }
    },
  );

  async function verifyCode() {
    try {
      await client.verifySignupCode(code.value);
      validCode.value = true;
    } catch (error: any) {
      console.log(error);
      code.error = error.detail;
    }
  }

  return (
    <>
      {!validCode.value ? (
        <div className="mt-10 flex justify-center">
          <div className="plate w-full max-w-md px-8 pt-7 pb-8">
            <h2 className="mt-1 text-2xl font-semibold text-secondary-800 uppercase">
              Enter sign-up code
            </h2>
            <div className="mt-6 flex flex-col gap-4">
              <Textfield
                control={code}
                label="Signup code"
                inputClass="form-control"
                onKeyDown={(e) => {
                  if (e.key === "Enter" && code.value) {
                    verifyCode();
                  }
                }}
              />
              <button
                disabled={!code.value}
                onClick={() => verifyCode()}
                className="btn btn-primary"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      ) : (
        <ApplicationForm code={code} />
      )}
    </>
  );
}

export default App;
